import React from 'react';
import { useParams } from 'react-router-dom';

import TableHeader from '../../../../../components/Table/TableHeader';
import TablePagination from '../../../../../components/Table/TablePagination';
import FormControl from '@material-ui/core/FormControl';
import InputSearch from '../../../../../components/InputSearch'

const tabelaColunas = ['GTIN/EAN', 'Descrição', 'Categoria', 'Marca', 'Status', '']

const ListaProdutoSeller = ({ subSellerPage, response, buscar, busca, mudarPagina }) => {

    const { idEmpresa } = useParams();

    const changePage = (page) => {
        mudarPagina(page)
    }

    const gotoDet = (idProdutoSeller) => {
        subSellerPage("editar-produto", idProdutoSeller)
    }

    return (
        <div>
            <div className="row justify-content-end">
                <div className='col-md-3'>
                    <FormControl>
                        <InputSearch
                            buscar={buscar}
                            buscaPor={busca}
                        />
                    </FormControl>
                </div>
            </div>

            <div className="row">
                <div className='col-12 mt20'>
                    <div className="table-responsive">
                        <table className="table">
                            <TableHeader columns={tabelaColunas} />

                            <tbody>
                                {
                                    (!response?.lista || response?.lista.length === 0) &&
                                    <tr><td colSpan="7"> Sem Registros </td></tr>
                                }
                                {
                                    response?.lista && response?.lista?.map((data) => (
                                        <tr key={data.id}>
                                            <td> {data.gtin} </td>
                                            <td> {data.nomeProduto} </td>
                                            <td> {data.categoria} </td>
                                            <td> {data.marca} </td>
                                            <td> {data.status ? "Ativo" : "Inativo"} </td>
                                            <td className="text-right">
                                                <i className="btn-edit-icon btn btn-icon fa fa-edit" onClick={() => gotoDet(data.id)}></i>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        <TablePagination data={response} changePage={changePage} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ListaProdutoSeller;